<template>
  <v-card class="mainContent theme-back" tile flat :dark="dark">
    <v-card class="sideCard theme-back" tile flat>
      <PlayerListSubstitute
          v-if="gamedata && gamedata.team_a_players && gamedata.team_b_players"
          :gamefinished="gamefinished"
          :persons="[...!isMirrored ? gamedata.team_a_players : gamedata.team_b_players]"
          :team="!isMirrored ? 'A' :'B'"
          :itemCount="maxTeamSize()"
          :started="!gameStarted"
          :isMirrored="isMirrored"
          :playerEntry="!isMirrored ? gamedata.team_a_players_entry : gamedata.team_b_players_entry"
          :canEntryPlayer="canEntryPlayer"
          :playtime="playerPlayTime"
          :gamedata="gamedata"
      />
    </v-card>

    <v-card class="midContent theme-back overflow-auto" tile flat v-on:scroll.native="handleScroll">
      <PlayerSelect v-if="!gameStarted && !isPassivePeriod(actualPeriod)" :teams="teamNamesAndPlayersNumber()" :isMirrored="isMirrored"/>
      <TimelineHeader v-if="gameStarted" :teams="teamNamesAndPlayersNumber()" :isMirrored="isMirrored" :gamefinished="gamefinished"/>

      <v-card v-if="gameStarted" flat tile class="transparent d-flex flex-nowrap align-center justify-space-around" height="50px" width="100%">
        <v-card flat tile width="50%" height="50px" class="transparent theme-title d-flex justify-end pl-2 pr-2">
          <v-card flat tile class="official-exclude-box transparent"
                  v-if="officialExcludes[!isMirrored ? 'A' : 'B'].length"
                  v-for="item in officialExcludes[!isMirrored ? 'A' : 'B']"
                  :key="'item-exclude-'+item.UUID">
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn depressed tile outlined class="delete-official-exclude theme-border theme-background ml-1 mr-1" v-on="on" @click="officialCancel(item, !isMirrored ? 'A' : 'B')">
                  <v-icon>mdi-account-clock</v-icon>
                </v-btn>
              </template>
              <span>Kiállítás törlése</span>
            </v-tooltip>
            <v-card flat tile class="official-time">{{item.remainingExclude}}</v-card>
          </v-card>

          <v-card flat tile class="transparent">
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn depressed tile outlined class="add-official-exclude theme-border theme-background ml-1 mr-1" v-on="on" @click="officialExclude(!isMirrored ? 'A' : 'B')">
                  <v-icon>mdi-account-remove</v-icon>
                </v-btn>
              </template>
              <span>Hivatalos személy kiállítása</span>
            </v-tooltip>
          </v-card>
        </v-card>

        <v-card flat tile width="50%" height="50px" class="transparent theme-title d-flex justify-start pl-2 pr-2">
          <v-card flat tile class="transparent">
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn depressed tile outlined class="add-official-exclude theme-border theme-background ml-1 mr-1" v-on="on" @click="officialExclude(!isMirrored ? 'B' : 'A')">
                  <v-icon>mdi-account-remove</v-icon>
                </v-btn>
              </template>
              <span>Hivatalos személy kiállítása</span>
            </v-tooltip>
          </v-card>

          <v-card flat tile class="official-exclude-box transparent"
                  v-if="officialExcludes[!isMirrored ? 'B' : 'A'].length"
                  v-for="item in officialExcludes[!isMirrored ? 'B' : 'A']"
                  :key="'item-exclude-'+item.UUID">
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-btn depressed tile outlined class="delete-official-exclude theme-border theme-background ml-1 mr-1" v-on="on" @click="officialCancel(item, !isMirrored ? 'B' : 'A')">
                  <v-icon>mdi-account-clock</v-icon>
                </v-btn>
              </template>
              <span>Kiállítás törlése</span>
            </v-tooltip>
            <v-card flat tile class="official-time">{{item.remainingExclude}}</v-card>
          </v-card>
        </v-card>
      </v-card>

      <TimelineSubstitute v-if="gameStarted" :timelineData="timelineItems" :isMirrored="isMirrored" :gamefinished="gamefinished" :lazyLoadItems="lazyLoadItems" :time="time"/>
    </v-card>

    <v-card class="sideCard theme-back" tile flat>
      <PlayerListSubstitute
          v-if="gamedata && gamedata.team_a_players && gamedata.team_b_players"
          :gamefinished="gamefinished"
          :persons="[...!isMirrored ? gamedata.team_b_players : gamedata.team_a_players]"
          :team="!isMirrored ? 'B' :'A'"
          :itemCount="maxTeamSize()"
          :started="!gameStarted"
          :isMirrored="isMirrored"
          :playerEntry="!isMirrored ? gamedata.team_b_players_entry : gamedata.team_a_players_entry"
          :canEntryPlayer="canEntryPlayer"
          :playtime="playerPlayTime"
          :gamedata="gamedata"
      />
    </v-card>

    <v-row justify="center" class="dialog-container">
      <SingleExcludeDialog
          :gamedata="gamedata"
          :playersStatus="playersStatus"
      />

      <RestoreDialog
          v-model="restoreDialog.show"
          :dialogData="restoreDialog"
          :gamedata="gamedata"
          :isMirrored="isMirrored"
          :playersStatus="playersStatus"
          @save="setPlayersPlaying"
          @cancel="restoreDialogDefault(true)"
      />
    </v-row>

    <v-alert v-show="alertBox" type="error" class="alertBox" transition="slide-y-reverse-transition">
      {{alertText}}
    </v-alert>
  </v-card>
</template>

<script>
var debug = require('debug')('MKSZ:SubstituteScreen');
import PlayerListSubstitute from "@/components/PlayerListSubstitute";
import TimelineSubstitute from "@/components/TimelineSubstitute";
import PlayerSelect from "@/components/PlayerSelect";
import TimelineHeader from "@/components/TimelineHeader";
import SingleExcludeDialog from "@/components/dialogs/SingleExcludeDialog";
import RestoreDialog from "@/components/dialogs/RestoreDialog";
import TimeFormatter from "@/TimeFormatter";
import eventBus from '@/eventBus';
import CONSTANTS from "@/constants";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
  name: 'SubstituteScreen',
  components: {
    PlayerListSubstitute,
    TimelineSubstitute,
    PlayerSelect,
    TimelineHeader,
    SingleExcludeDialog,
    RestoreDialog
  },
  props: {
    dark: Boolean,
    isLoggedin: Boolean,
    isMirrored: Boolean,
    hotkeys: {
      type: Boolean,
      default: true
    },
    gamedata: Object,
    substituteTimeline: Array,
    period: String,
    gamefinished: Boolean
  },
  data: function () {
    return {
      time: '00:00',
      maxActivePlayers: 7,
      lazyLoadItems: 20,
      gameStarted: false,
      actualPeriod: '1',
      alertBox: false,
      alertText: '',
      editingTimeline: [],
      restoreDialog: {
        show: false,
        teams: {
          A: [],
          B: [],
        },
        UUID: null,
        time: '00:00',
        totalGameTime: 0
      },
      storeExcludes: [],
      canEntryPlayer: true,
      singleExcludeDialog: {
        show: false,
        selected: null,
        player: {},
        team: '',
        time: '00:00',
      },
      lastKnownStopwatch: 0,
      wasRunning: false,
    }
  },
  watch: {
    substituteTimeline: {
      handler(val) {
        if (val && val.length) {
          this.initSubstituteData({
            substituteTimeline: val,
            period: this.actualPeriod
          });

          this.$nextTick(() => {
            this.loadPeriod(this.allItems, this.actualPeriod, this.gameStarted);
          });
        }
      },
      deep: true
    },
    period: {
      handler(val) {
        if (val) {
          this.actualPeriod = val;
          this.initSubstituteData({
            substituteTimeline: this.substituteTimeline,
            period: val
          });
        }
      }
    },
    'restoreDialog.show': function (val) {
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, val);
    },
    'singleExcludeDialog.show': function (val) {
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, val);
    }
  },
  created() {
    let self = this;

    if (!self.isLoggedin) {
      self.$router.push("/login");
      return;
    }

    if (self.period) {
      self.actualPeriod = self.period;
    }

    // Ha elindul az óra, megjegyezzük -> RC esetén tudni fogjuk, hogy folytatni kell
    this.$busOn(CONSTANTS.EVENTS.CLOCK.STARTED, function () {
      self.wasRunning = true;
    });

    // Ha megáll az óra, megjegyezzük -> RC esetén nem indul újra magától
    this.$busOn(CONSTANTS.EVENTS.CLOCK.PAUSED, function () {
      self.wasRunning = false;
    });

    this.$busOn(CONSTANTS.EVENTS.CHANGE.CONNECTION, function(value) {
      switch(value) {
        case 'okfromsync':
        case 'ok':
        case 'sync':
          self.canEntryPlayer = false;
          break;
        case 'error':
        default:
          self.canEntryPlayer = true;
          break;
      }
    });
    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.SYNC, data => {
      if (data.type === "playerPicked") {
        debug("data", data);
        let teamText = self.getTeamKey(data.content.team);
        let localGameData = Object.assign({}, self.gamedata);

        let exists = [localGameData].find(player => player.id === data.content.player.id);
        if(!exists) {
          let cards = {
            yellow: { value: false, given: undefined },
            red: { value: false, given: undefined },
            blue: { value: false, given: undefined }
          };

          localGameData[teamText].push({
            id: data.content.player.id,
            name: data.content.player.name,
            jersey: data.content.player.jersey,
            goalkeeper: Boolean(data.content.player.goalkeeper),
            cards: data.content.player.cards ? data.content.player.cards : cards,
            disabled: data.content.player.disabled ? data.content.player.disabled : false,
            excluded: data.content.player.excluded ? data.content.player.excluded : false,
            maxPenalties: data.content.player.maxPenalties ? data.content.player.maxPenalties : 3,
            penalties: data.content.player.penalties ? data.content.player.penalties : [],
            playing: data.content.player.playing ? data.content.player.playing : false,
            remainingExclude: "",
            selected: data.content.player.selected ? data.content.player.selected : false,
            team: data.content.team
          });

          if(data.content.player.playerEntryScreen === 'report') {
            window.dbmanager.readAll().then(function(rows) {
              if(rows) {
                rows.forEach(function(row) {
                  if(row.action === 'player_entry' && row.params && row.params.player && row.params.player.playerEntryScreen === 'substitute') {
                    let teamText = row.params.player.team === 'teamA' ? 'team_a_players' : 'team_b_players';
                    let playerIndex = localGameData[teamText].findIndex(player => player.id === row.params.player.id);
                    if(playerIndex !== -1) {
                      switch(teamText) {
                        case 'team_a_players':
                          localGameData.team_a_players_entry.push(localGameData[teamText][playerIndex]);
                          break;
                        case 'team_b_players':
                          localGameData.team_b_players_entry.push(localGameData[teamText][playerIndex]);
                          break;
                      }
                      localGameData[teamText].splice(playerIndex, 1);
                    }
                  }
                });
                eventBus.$emit(CONSTANTS.EVENTS.SET.GAMEDATA, localGameData);
              }
            });
          }
          else {
            eventBus.$emit(CONSTANTS.EVENTS.SET.GAMEDATA, localGameData);
          }
        }
      }
    });
    this.$busOn(CONSTANTS.EVENTS.TIMELINE.ITEM.DELETE.ALL, function (time) {
      let deletedUUIDs = [];

      [...self.timelineData].forEach(function (item) {
        let deletable = false;

        if(item.time === time && ['Kiállítás', 'Hivatalos Kiállítás', 'Csere', 'Felmegy'].includes(item.action) && !item.hidden) {
          switch(true) {
            // 79. tétel: az előző félidőből átnyúló kiállítást lezáró "Felmegy" nem törölhető
            // (korábban: item.time < '02:00', ami az abszolút óraidő óta nem működik).
            case (item.action === 'Felmegy') && self.isCarriedRestore(item): break;
            case (item.action === 'Felmegy' && !self.isCarriedRestore(item)): {
              let excludedItem = self.getExcludedItem(item);
              if(!excludedItem.hidden) {
                if(excludedItem.excluded && excludedItem.down && excludedItem.excluded.id === excludedItem.down.id) {
                  deletable = true;
                } else {
                  let crossAction = false;
                  self.timelineData.forEach(function (tmpItem) {
                    if(tmpItem.team === item.team &&
                        ((tmpItem.excluded && tmpItem.excluded.id === excludedItem.down.id) ||
                            (tmpItem.down && tmpItem.down.id === excludedItem.down.id) ||
                            (tmpItem.up && tmpItem.up.id === excludedItem.down.id)) &&
                        ((TimeFormatter.stringToInt(item.time) > TimeFormatter.stringToInt(tmpItem.time)) && (TimeFormatter.stringToInt(excludedItem.time) <= TimeFormatter.stringToInt(tmpItem.time))) &&
                        (tmpItem.UUID !== item.UUID && tmpItem.UUID !== excludedItem.UUID && !deletedUUIDs.includes(tmpItem.UUID))) {
                      crossAction = true;
                    }
                  });
                  if(!crossAction) {
                    deletable = true;
                  }
                }
                if(deletable) {
                  deletedUUIDs.push(excludedItem.UUID);
                  if (!excludedItem.excluded) {
                    let currentExcludes = self.officialExcludes[item.team].filter((subItem) => {
                      return subItem.UUID !== excludedItem.UUID;
                    });
                    let allExcludes = {...self.officialExcludes};
                    allExcludes[item.team] = currentExcludes;
                    self.officialExcludes = allExcludes;
                  }
                }
              }
              break;
            }
            case (['Kiállítás', 'Hivatalos Kiállítás'].includes(item.action)): {
              item.duration = item.duration ?? "02:00";
              let currentPeriod = self.getPeriodData(self.actualPeriod);
              let started = TimeFormatter.stringToInt(item.time);
              let duration = TimeFormatter.stringToInt(item.duration);
              let end = started + duration;
              // JAVÍTÁS (TELJESÍTMÉNY): a modul-feloldás, az `isStrand` és az
              // (elemtől független!) `pActual` korábban a szűrő BELSEJÉBEN,
              // tehát MINDEN egyes elemnél újra kiszámolódott - ráadásul ez a
              // blokk maga is elemenként fut, ami négyzetes költséget adott.
              const isStrand = self.$store.state.game.gamedata && self.$store.state.game.gamedata.rule === 'STRAND';
              const getChronoOrderForExclusion = require('@/utils/periodOrder').getChronoOrder;
              const pActual = getChronoOrderForExclusion(self.actualPeriod, isStrand);
              let nextPeriodItems = self.allItems.filter((tmpItem) => {
                return getChronoOrderForExclusion(tmpItem.period, isStrand) > pActual;
              });

              let periodDuration = currentPeriod ? parseInt(currentPeriod.duration || 1800) : 1800;
              if(!item.hidden &&  ((periodDuration >= end) || !nextPeriodItems.length)) {
                deletable = true;
                if(item.action === 'Hivatalos Kiállítás') {
                  let currentExcludes = self.officialExcludes[item.team].filter((subItem) => {
                    return subItem.UUID !== item.UUID;
                  });
                  let allExcludes = {...self.officialExcludes};
                  allExcludes[item.team] = currentExcludes;
                  self.officialExcludes = allExcludes;
                }
              }
              break;
            }
            default:
              deletable = true;
              break;
          }
        }
        if(deletable) {
          deletedUUIDs.push(item.UUID);
        }
      });

      if(deletedUUIDs.length) {
        let newTimeline = self.timelineData.filter(function (item) {
          let deletable = deletedUUIDs.includes(item.UUID);
          if(deletable) {
            self.deleteEvent(item);
          }
          return !deletable;
        });
        self.timelineData = newTimeline;
        self.$nextTick(() => {
          self.loadStatusToTime(window.stopwatch.getTotalTimeAsString());
        });
      } else {
        self.showAlert();
      }
    });
    this.$busOn(CONSTANTS.EVENTS.TIMELINE.ITEM.EDIT.ONE, function (editItem) {
      if(!self.editingTimeline.length) {
        let editedTable = [];
        let timelineTable = [];
        let denyAction = false;

        self.timelineData.forEach(function (item) {
          if (editItem.UUID === item.UUID) {
            editedTable.push({...item, editing: true});
            timelineTable.push({...item, editing: true});
            let teamText = self.getTeamKey(item.team);

            if(item.action === "Felmegy") {
              if (self.getPlayer(item.up.id, teamText).excluded || !self.getPlayer(item.up.id, teamText).playing) {
                denyAction = true;
              }
            }
            if(item.action === "Csere") {
              if(self.getPlayer(item.up.id, teamText).excluded || self.getPlayer(item.down.id, teamText).excluded || !self.getPlayer(item.up.id, teamText).playing || self.getPlayer(item.down.id, teamText).playing) {
                denyAction = true;
              } else {
                self.setPlayer('playing', false, item.up.id, teamText);
                self.setPlayer('selected', true, item.up.id, teamText);
                self.setPlayer('playing', true, item.down.id, teamText);
                self.setPlayer('selected', true, item.down.id, teamText);
              }
            }
          } else {
            timelineTable.push({...item, editing: false});
          }
        });

        if(denyAction) {
          self.showAlert();
        } else {
          self.timelineData = timelineTable;
          self.editingTimeline = editedTable;
        }
      } else {
        self.showAlert('Egyszerre csak egy esemény szerkeszthető!');
      }
    });
    this.$busOn(CONSTANTS.EVENTS.TIMELINE.ITEM.EDIT.ALL, function (time) {
      let timelineTable = [];
      let editedTable = [];

      self.timelineData.forEach(function (item, index) {
        timelineTable.push(item);
        if (item.time === time && item.action !== "Kezdőjátékos" && !item.hidden) {
          editedTable.push({...item, editing: true});
          timelineTable[index].editing = true;
          if(item.action === "Csere") {
            let teamText = self.getTeamKey(item.team);
            if(!self.getPlayer(item.up.id, teamText).excluded && !self.getPlayer(item.down.id, teamText).excluded) {
              self.setPlayer('playing', !self.getPlayer(item.up.id, teamText).playing, item.up.id, teamText);
              self.setPlayer('selected', true, item.up.id, teamText);
              self.setPlayer('playing', !self.getPlayer(item.down.id, teamText).playing, item.down.id, teamText);
              self.setPlayer('selected', true, item.down.id, teamText);
            }
          }
        } else {
          timelineTable[index].editing = false;
        }
      });
      self.timelineData = timelineTable;
      self.editingTimeline = editedTable;
    });
    this.$busOn(CONSTANTS.ACTIONS.TOGGLE.PLAYER.PLAY, function (play, player, team) {
      let teamText = self.getTeamKey(team);
      if (!play || (play && (self.maxActivePlayers > (self.activePlayersNumber(team) + self.getExcludedPlayers(team))))) {
        if (play) {
          if (!self.canGoalkeeper(self.gamedata[teamText], player.goalkeeper, 'playing')) {
            self.gamedata[teamText].forEach(player => {
              if (player.goalkeeper && player.playing) {
                self.setPlayer('playing', false, player.id, teamText);
              }
            });
          }
        }
        self.setPlayer('playing', play, player.id, teamText);
      }
    });
    this.$busOn(CONSTANTS.EVENTS.TIMELINE.ITEM.EDIT.UP, function (item, team) {
      let teamText = self.getTeamKey(team);
      if(self.getPlayer(item.up.id, teamText).playing) {
        self.setPlayer('playing', false, item.up.id, self.getTeamKey(team));
        let restoredExcludes = { A: [], B: [], time: item.time, totalGameTime: item.totalGameTime };
        restoredExcludes[team].push({
          down: item.down,
          up: item.up,
          excluded: item.excluded,
          selected: item.up.id,
        });
        self.restoreDialog.UUID = item.UUID;
        self.setExcludesDialog(restoredExcludes);
      } else {
        self.showAlert();
      }
    });

    this.$busOn(CONSTANTS.ACTIONS.EXCLUDEOFFICIAL, function (excluded, player, team, officialData) {
      let teamText = self.getTeamKey(team);
      if(excluded && player && self.getPlayer(player.id, teamText).selected) {
        eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.PLAYER.SELECT, false, self.getPlayer(player.id, teamText), team);
      }

      if (excluded) {
        // JAVÍTÁS: a getTotalTimeAsString() MÁR abszolút (meccs eleje óta eltelt) időt ad
        // vissza, nem szabad még egyszer hozzáadni a félidő-kezdetet (getPeriodStartTime),
        // különben a 2. félidőtől (és utána) duplán számolja be azt.
        let clockSeconds = TimeFormatter.stringToInt(window.stopwatch.getTotalTimeAsString());

        let theTime = TimeFormatter.intToString(clockSeconds);
        let totalGameTime = clockSeconds;

        let duration = '02:00';
        let UUID = window.dbmanager.generateUUID();

        if (self.isEditing(self.editingTimeline)) {
          theTime = self.editingTimeline[0].time;
          totalGameTime = self.editingTimeline[0].totalGameTime;
        }

        self.createEvent({
          UUID: UUID,
          team: team,
          up: null,
          down: { id: player.id, jersey: player.jersey, name: player.name },
          excluded: null,
          action: 'Hivatalos Kiállítás',
          time: theTime,
          totalGameTime: totalGameTime,
          duration: duration,
          period: self.actualPeriod,
          editing: false,
          isNew: false,
        });

        let newOfficialExcludes = {...self.officialExcludes};
        newOfficialExcludes[team] = [...newOfficialExcludes[team], {
          UUID: UUID,
          downId: player.id,
          remainingExclude: duration,
        }];
        self.officialExcludes = newOfficialExcludes;
        self.setPlayer('playing', false, player.id, teamText);
      } else {
        let lastExclude = {};
        [...self.timelineData].forEach(function (item) {
          if (item.action === "Hivatalos Kiállítás" && item.UUID === officialData.UUID) {
            lastExclude = item;
          }
        });
        if(lastExclude.hidden) {
          self.showAlert();
        } else {
          eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.DELETE.ONE, lastExclude.UUID, {down: lastExclude.down}, lastExclude.team);
        }
      }
    });

    this.$busOn(CONSTANTS.ACTIONS.EXCLUDEPLAYER, function (excluded, player, team, downPlayer, type = 1) {
      let teamText = self.getTeamKey(team);
      if(excluded && player && self.getPlayer(player.id, teamText).selected) {
        eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.PLAYER.SELECT, false, self.getPlayer(player.id, teamText), team);
      }
      if(excluded && downPlayer && self.getPlayer(downPlayer.id, teamText).selected) {
        eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.PLAYER.SELECT, false, self.getPlayer(downPlayer.id, teamText), team);
      }

      self.setPlayer('excluded', excluded, player.id, teamText);
      let saveDown = downPlayer ? downPlayer : player;
      saveDown = { id: saveDown.id, jersey: saveDown.jersey, name: saveDown.name };

      if (excluded) {
        // JAVÍTÁS: ld. az EXCLUDEOFFICIAL handlerben lévő azonos hiba magyarázatát -
        // getTotalTimeAsString() már abszolút, nem kell hozzáadni a félidő-kezdetet.
        let clockSeconds = TimeFormatter.stringToInt(window.stopwatch.getTotalTimeAsString());

        let theTime = TimeFormatter.intToString(clockSeconds);
        let totalGameTime = clockSeconds;

        let duration = '02:00';
        if (type === 2) duration = '04:00';

        if (self.isEditing(self.editingTimeline)) {
          theTime = self.editingTimeline[0].time;
          totalGameTime = self.editingTimeline[0].totalGameTime;
        }

        self.createEvent({
          UUID: window.dbmanager.generateUUID(),
          team: team,
          up: null,
          down: saveDown,
          excluded: { id: player.id, jersey: player.jersey, name: player.name },
          action: 'Kiállítás',
          time: theTime,
          totalGameTime: totalGameTime,
          duration: duration,
          period: self.actualPeriod,
          editing: false,
          isNew: false,
        });

        self.setPlayer('playing', false, saveDown.id, teamText);
        self.setPlayer('remainingExclude', duration, player.id, teamText);
      } else {
        let lastExclude = {};
        [...self.timelineData].forEach(function (item) {
          if (item.action === "Kiállítás" && item.excluded.id === player.id) {
            let remainingSeconds = TimeFormatter.stringToInt(self.getPlayer(item.excluded.id, teamText).remainingExclude);
            let actualTimeInSeconds = TimeFormatter.stringToInt(window.stopwatch.getTotalTimeAsString());

            if (type === 2) {
              if (item.time === TimeFormatter.intToString(actualTimeInSeconds+remainingSeconds-240)) lastExclude = item;
            } else {
              if (item.time === TimeFormatter.intToString(actualTimeInSeconds+remainingSeconds-120)) lastExclude = item;
            }
          }
        });
        if(!lastExclude.hidden) {
          eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.DELETE.ONE, lastExclude.UUID, {down: lastExclude.down, excluded: lastExclude.excluded}, lastExclude.team);
        } else {
          self.showAlert();
        }
      }
    });

    this.$busOn(CONSTANTS.ACTIONS.TOGGLE.PLAYER.SELECT, function (selected, player, team) {
      if(selected && self.editingTimeline.length) {
        let editingAnotherItem = false;
        self.editingTimeline.forEach(function (item) {
          if(item.action !== 'Csere') editingAnotherItem = true;
        });
        if(editingAnotherItem) {
          self.showAlert('Egy másik esemény szerkesztése van folyamatban, egyszerre csak egy elem szerkeszthető!');
          return false;
        }
      }

      let teamText = self.getTeamKey(team);
      let editedTable = [...self.editingTimeline];
      let position = player.playing ? 'down' : 'up';
      let inversePosition = player.playing ? 'up' : 'down';
      let foundItem = {};
      let foundPosition = false;
      let goalkeeperSwapId = false;
      let anotherGoalkeeperSelected = false;

      // JAVÍTÁS: ld. az EXCLUDEOFFICIAL handlerben lévő azonos hiba magyarázatát -
      // getTotalTimeAsString() már abszolút, nem kell hozzáadni a félidő-kezdetet.
      let clockSeconds = TimeFormatter.stringToInt(window.stopwatch.getTotalTimeAsString());

      let theTime = TimeFormatter.intToString(clockSeconds);
      let totalGameTime = clockSeconds;

      let autoSave = false;

      if (selected && player.goalkeeper && !player.playing) {
        self.gamedata[teamText].forEach(function (plr) {
          if(!anotherGoalkeeperSelected && plr.goalkeeper && !plr.playing && plr.selected && plr.id !== player.id) {
            anotherGoalkeeperSelected = true;
          }
        });
        if(anotherGoalkeeperSelected) return false;

        self.editingTimeline.forEach(item => {
          if(item.team === team && !item.up) {
            if(self.getPlayer(item.down.id, teamText).goalkeeper) goalkeeperSwapId = item.UUID;
          }
        });
        if (!goalkeeperSwapId && !self.canGoalkeeper(self.gamedata[teamText], player.goalkeeper, 'playing')) {
          return false;
        }
      }

      self.setPlayer('selected', selected, player.id, teamText);

      if (selected) {
        let savePlayer = { id: player.id, jersey: player.jersey, name: player.name };

        if (self.isEditing(self.editingTimeline)) {
          theTime = self.editingTimeline[0].time;
          totalGameTime = self.editingTimeline[0].totalGameTime;
          self.editingTimeline.forEach(function (item, index) {
            if(!foundPosition && item.action === "Csere") {
              if(goalkeeperSwapId) {
                if(item.UUID === goalkeeperSwapId) {
                  editedTable[index][position] = savePlayer;
                  foundItem = editedTable[index];
                  foundPosition = true;
                }
              } else {
                if (item.team === team) {
                  if (!item[position]) {
                    editedTable[index][position] = savePlayer;
                    foundItem = editedTable[index];
                    foundPosition = true;
                  }
                }
              }
            }
          });
        }

        if (foundPosition) {
          self.editingTimeline = editedTable;
          if(foundItem.up && foundItem.down && foundItem.up.id && foundItem.down.id) {
            if(window.autosave && window.saveTime === 0) autoSave = true;
          }
        } else {
          self.editingTimeline.push({
            UUID: window.dbmanager.generateUUID(),
            team: team,
            down: player.playing ? savePlayer : null,
            up: player.playing ? null : savePlayer,
            excluded: null,
            action: 'Csere',
            time: theTime,
            totalGameTime: totalGameTime,
            period: self.actualPeriod,
            editing: true,
            isNew: true,
          });
        }
      } else {
        self.editingTimeline.forEach(function (item) {
          if(item.team === team) {
            [position, inversePosition].forEach(function (pos) {
              if(item[pos] && item[pos].id === player.id) {
                let invPos = pos === "up" ? "down" : "up";
                if(item[invPos]) {
                  editedTable.forEach(function (subItem, subIndex) {
                    if(subItem.UUID === item.UUID) {
                      editedTable[subIndex][pos] = null;
                      let ordering = false;
                      editedTable.forEach(function (tmpItem, tmpIndex) {
                        if (tmpItem.team === subItem.team) {
                          if (!ordering && !tmpItem[invPos] && tmpItem[pos]) {
                            ordering = true;
                            if(tmpItem.isNew) {
                              editedTable[subIndex][pos] = tmpItem[pos];
                              editedTable[tmpIndex][pos] = null;
                            } else if(subItem.isNew) {
                              editedTable[tmpIndex][invPos] = subItem[invPos];
                              editedTable[subIndex][invPos] = null;
                            }
                          }
                        }
                      });
                      editedTable = editedTable.filter(function (tmp) {
                        return tmp.action === "Csere" && ((tmp.up || tmp.down) || !tmp.isNew);
                      });
                    }
                  });
                } else {
                  if (item.isNew) {
                    editedTable = editedTable.filter(function (subItem) {
                      return subItem.UUID !== item.UUID;
                    });
                  } else {
                    editedTable.forEach(function (subItem, subIndex) {
                      if(subItem.UUID === item.UUID) {
                        editedTable[subIndex][pos] = null;
                      }
                    });
                  }
                }
              }
            });
          }
        });
        self.editingTimeline = editedTable;
      }

      if(!selected && player.goalkeeper && player.playing) {
        self.gamedata[teamText].forEach(plr => {
          if(self.getPlayer(plr.id, teamText).selected && plr.id !== player.id && plr.goalkeeper) {
            eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.PLAYER.SELECT, false, self.getPlayer(plr.id, teamText), team);
          }
        });
      }

      if (autoSave) {
        let savePlayers = { up: foundItem.up, down: foundItem.down };
        self.$nextTick(() => {
          eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.SAVE.ONE, foundItem.UUID, savePlayers, foundItem.team, true);
        });
      }
    });

    this.$busOn(CONSTANTS.EVENTS.TIMELINE.ITEM.DELETE.ONE, function (UUID, players, team) {
      let timelineTable = [];
      let editedTable = [];
      let deleteCancel = false;
      let excludedItem = false;
      let periodEndItem = false;
      let itemTime = '00:00';
      let deletedTime = '00:00';

      self.timelineData.forEach(function (item) {
        if(item.UUID === UUID) {
          deletedTime = item.time;
        } else {
          if(itemTime < item.time) itemTime = item.time;
        }
      });

      if(deletedTime >= itemTime && deletedTime <= window.stopwatch.getTotalTimeAsString()) {
        self.timelineData.forEach(function (item) {
          if (item.UUID !== UUID) {
            timelineTable.push(item);
          } else {
            let teamText = self.getTeamKey(team);

            if (item.action === 'Felmegy') {
              excludedItem = self.getExcludedItem(item);
              let deletable = false;
              if(!excludedItem.hidden) {
                if(excludedItem.excluded && excludedItem.down && excludedItem.excluded.id === excludedItem.down.id) {
                  deletable = true;
                } else {
                  let crossAction = false;
                  self.timelineData.forEach(function (tmpItem) {
                    if(tmpItem.team === item.team &&
                        ((tmpItem.excluded && tmpItem.excluded.id === excludedItem.down.id) ||
                            (tmpItem.down && tmpItem.down.id === excludedItem.down.id) ||
                            (tmpItem.up && tmpItem.up.id === excludedItem.down.id)) &&
                        ((TimeFormatter.stringToInt(item.time) >= TimeFormatter.stringToInt(tmpItem.time)) && (TimeFormatter.stringToInt(excludedItem.time) <= TimeFormatter.stringToInt(tmpItem.time))) &&
                        (tmpItem.UUID !== item.UUID && tmpItem.UUID !== excludedItem.UUID)) {
                      crossAction = true;
                    }
                  });
                  if(!crossAction) deletable = true;
                }
              }

              if (deletable && self.getPlayer(item.up.id, teamText).playing && (!self.getPlayer(excludedItem.down.id, teamText).playing || item.up.id === excludedItem.down.id) && !self.isCarriedRestore(item)) {
                if(item.excluded && self.getPlayer(item.excluded.id, teamText).excluded) {
                  self.setPlayer('excluded', false, item.excluded.id, teamText);
                  self.setPlayer('remainingExclude', '', item.excluded.id, teamText);
                }
                if(!item.excluded) {
                  let currentExcludes = self.officialExcludes[item.team].filter((subItem) => {
                    return subItem.UUID !== excludedItem.UUID;
                  });
                  let allExcludes = {...self.officialExcludes};
                  allExcludes[item.team] = currentExcludes;
                  self.officialExcludes = allExcludes;
                }
                self.setPlayer('playing', false, item.up.id, teamText);
                self.setPlayer('playing', true, excludedItem.down.id, teamText);
                self.deleteEvent(excludedItem);
              } else {
                deleteCancel = true;
              }
            } else if (item.action === 'Csere') {
              if (self.canActionDelete(item) && !self.getPlayer(item.up.id, teamText).playing && self.getPlayer(item.down.id, teamText).playing && !self.getPlayer(item.up.id, teamText).excluded && !self.getPlayer(item.down.id, teamText).excluded) {
                self.setPlayer('playing', false, item.up.id, teamText);
                self.setPlayer('playing', true, item.down.id, teamText);
                self.setPlayer('selected', false, item.up.id, teamText);
                self.setPlayer('selected', false, item.down.id, teamText);
              } else {
                deleteCancel = true;
              }
            } else if (item.action === 'Kiállítás') {
              item.duration = item.duration ?? "02:00";
              let currentPeriod = self.getPeriodData(self.actualPeriod);
              let remaining = (currentPeriod ? parseInt(currentPeriod.duration || 1800) : 1800) - TimeFormatter.stringToInt(item.time);
              let duration = TimeFormatter.stringToInt(item.duration);
              let nextPeriodItems = self.allItems.filter((tmpItem) => {
                return tmpItem.period > self.actualPeriod;
              });

              if (remaining < duration && nextPeriodItems.length) {
                deleteCancel = true;
                periodEndItem = true;
              } else {
                let deletable = false;
                if(item.excluded && item.down && item.excluded.id === item.down.id) {
                  deletable = true;
                } else {
                  let crossAction = false;
                  self.timelineData.forEach(function (tmpItem) {
                    if(((tmpItem.excluded && tmpItem.excluded.id === item.down.id) ||
                            (tmpItem.down && tmpItem.down.id === item.down.id) ||
                            (tmpItem.up && tmpItem.up.id === item.down.id)) &&
                        (TimeFormatter.stringToInt(item.time) < TimeFormatter.stringToInt(tmpItem.time)) &&
                        (tmpItem.UUID !== item.UUID)
                    ) {
                      crossAction = true;
                    }
                  });
                  if(!crossAction) deletable = true;
                }

                if(deletable && !item.hidden && !self.getPlayer(item.down.id, teamText).playing) {
                  if(self.getPlayer(item.excluded.id, teamText).excluded) {
                    self.setPlayer('excluded', false, item.excluded.id, teamText);
                    self.setPlayer('remainingExclude', '', item.excluded.id, teamText);
                  }
                  self.setPlayer('playing', true, item.down.id, teamText);
                } else {
                  deleteCancel = true;
                }
              }
            } else if (item.action === 'Hivatalos Kiállítás') {
              item.duration = item.duration ?? "02:00";
              let currentPeriod = self.getPeriodData(self.actualPeriod);
              let remaining = (currentPeriod ? parseInt(currentPeriod.duration || 1800) : 1800) - TimeFormatter.stringToInt(item.time);
              let duration = TimeFormatter.stringToInt(item.duration);
              let nextPeriodItems = self.allItems.filter((tmpItem) => {
                return tmpItem.period > self.actualPeriod;
              });

              if (remaining < duration && nextPeriodItems.length) {
                deleteCancel = true;
                periodEndItem = true;
              } else {
                let deletable = false;
                if(item.excluded && item.down && item.excluded.id === item.down.id) {
                  deletable = true;
                } else {
                  let crossAction = false;
                  self.timelineData.forEach(function (tmpItem) {
                    if(((tmpItem.excluded && tmpItem.excluded.id === item.down.id) ||
                            (tmpItem.down && tmpItem.down.id === item.down.id) ||
                            (tmpItem.up && tmpItem.up.id === item.down.id)) &&
                        (TimeFormatter.stringToInt(item.time) < TimeFormatter.stringToInt(tmpItem.time)) &&
                        (tmpItem.UUID !== item.UUID)
                    ) {
                      crossAction = true;
                    }
                  });
                  if(!crossAction) deletable = true;
                }

                if(deletable && !item.hidden && !self.getPlayer(item.down.id, teamText).playing) {
                  let currentExcludes = self.officialExcludes[team].filter((item) => {
                    return item.UUID !== UUID;
                  });
                  let allExcludes = {...self.officialExcludes};
                  allExcludes[team] = currentExcludes;
                  self.officialExcludes = allExcludes;
                  self.setPlayer('playing', true, item.down.id, teamText);
                } else {
                  deleteCancel = true;
                }
              }
            }

            if(!deleteCancel) {
              self.deleteEvent(item);
            }
          }
        });

        if(deleteCancel) {
          self.showAlert(periodEndItem ? 'Az esemény törlése kihatással lenne a következő félidő kezdetére, ezért nem törölhető!' : null);
        } else {
          self.editingTimeline.forEach(function (item) {
            if (item.UUID !== UUID) {
              editedTable.push(item);
            }
          });
          if(excludedItem) {
            editedTable = editedTable.filter(function (item) {
              return excludedItem.UUID !== item.UUID;
            });
            timelineTable = timelineTable.filter(function (item) {
              return excludedItem.UUID !== item.UUID;
            });
          }
          self.timelineData = timelineTable;
          self.editingTimeline = editedTable;
        }
      } else {
        self.showAlert('A törléshez az órát a törlés időpontjára kell állítania.');
      }
    });

    // --- EZ HIÁNYZOTT: Órajel figyelése és játékidő számolása ---
    this.$busOn(CONSTANTS.EVENTS.CLOCK.TICK, function (newTime) {
      let newFixedTime = TimeFormatter.fixFormat(newTime);

      let currentStopwatch = TimeFormatter.stringToInt(newFixedTime);
      if (currentStopwatch > 0) {
        self.lastKnownStopwatch = currentStopwatch;
      }

      let passivePeriod = self.isPassivePeriod(self.actualPeriod);

      // JAVÍTÁS: a CLOCK.TICK eseményben kapott newTime (Clock.vue getDisplayTime-ja)
      // MÁR abszolút (meccs eleje óta eltelt) idő - a clock.js state.minutes/seconds a
      // stopwatch.getTotalTime()-ból származik. Itt korábban még egyszer hozzáadta a
      // félidő-kezdetet (getPeriodStartTime), ami a 2. félidőtől duplázta az eltelt
      // időt - ez okozta, hogy a pályán lévő játékosok ideje 30:00 helyett 60:00-ról
      // kezdett el számolni a 2. félidő indításakor.
      let tickSeconds = TimeFormatter.stringToInt(newFixedTime);

      let currentAbsoluteTime = TimeFormatter.intToString(tickSeconds);
      let currentAbsoluteSeconds = tickSeconds;

      let playersHasAction = {
        team_a_players: [],
        team_b_players: [],
      };

      [...self.timelineData].sort(self.compareInc).forEach(function (item) {
        let teamText = self.getTeamKey(item.team);

        // Toleranciasáv (2 mp) a "jövőbeli" események kezelésére
        // Ez védi meg a rendszert attól, hogy RC után letiltson játékosokat
        let tolerance = 2;
        let itemSeconds = TimeFormatter.stringToInt(item.time);

        if (!passivePeriod && itemSeconds > (currentAbsoluteSeconds + tolerance)) {
          if (item.up && item.up.id && !playersHasAction[teamText].includes(item.up.id)) playersHasAction[teamText].push(item.up.id);
          if (item.down && item.down.id && !playersHasAction[teamText].includes(item.down.id)) playersHasAction[teamText].push(item.down.id);
          if (item.excluded && item.excluded.id && !playersHasAction[teamText].includes(item.excluded.id)) playersHasAction[teamText].push(item.excluded.id);
        }

        if (["Hivatalos Kiállítás", "Kiállítás"].includes(item.action)) {
          item.duration = item.duration ?? "02:00";
          let actualSeconds = currentAbsoluteSeconds;
          let createdSeconds = TimeFormatter.stringToInt(item.time);
          let durationSeconds = TimeFormatter.stringToInt(item.duration);
          let endDate = TimeFormatter.intToString(createdSeconds + durationSeconds);

          if(self.isActiveExclude(item.time, item.duration, currentAbsoluteTime)) {
            if(item.action === "Kiállítás" && self.isCarriedExclude(item) && (actualSeconds < createdSeconds + durationSeconds) && !playersHasAction[teamText].includes(item.excluded.id)) {
              playersHasAction[teamText].push(item.excluded.id);
            }
            let currentExcludes = self.officialExcludes[item.team].filter((subItem) => {
              return subItem.UUID !== item.UUID;
            });
            let allExcludes = {...self.officialExcludes};
            allExcludes[item.team] = currentExcludes;
            self.officialExcludes = allExcludes;

            if(actualSeconds < (createdSeconds + durationSeconds)) {
              if(item.action === 'Kiállítás') {
                self.setPlayer('excluded', true, item.excluded.id, teamText);
                self.setPlayer('remainingExclude', TimeFormatter.intToString(Math.abs(actualSeconds - createdSeconds - durationSeconds)), item.excluded.id, teamText);
              }
              if(item.action === 'Hivatalos Kiállítás') {
                let newOfficialExcludes = {...self.officialExcludes};
                newOfficialExcludes[item.team].push({
                  UUID: item.UUID,
                  downId: item.down.id,
                  remainingExclude: TimeFormatter.intToString(Math.abs(actualSeconds - createdSeconds - durationSeconds)),
                });
                self.officialExcludes = newOfficialExcludes;
              }
            } else {
              if(item.action === 'Kiállítás') {
                self.setPlayer('excluded', false, item.excluded.id, teamText);
                self.setPlayer('remainingExclude', '', item.excluded.id, teamText);
              }
            }
          } else {
            let currentExcludes = self.officialExcludes[item.team].filter((subItem) => {
              return subItem.UUID !== item.UUID;
            });
            let allExcludes = {...self.officialExcludes};
            allExcludes[item.team] = currentExcludes;
            self.officialExcludes = allExcludes;
          }

          if (currentAbsoluteTime >= endDate) {
            let haveExcludeUp = false;
            self.timelineData.find(function (subItem) {
              if(!haveExcludeUp && subItem.time === endDate && subItem.action === "Felmegy") {
                if(item.action === "Kiállítás" && subItem.excluded && subItem.excluded.id === item.excluded.id) { haveExcludeUp = subItem; return true; }
                if(item.action === "Hivatalos Kiállítás" && !subItem.excluded && subItem.down.id === item.down.id) { haveExcludeUp = subItem; return true; }
              }
            });

            if(!haveExcludeUp) {
              let storedYet = false;
              self.storeExcludes.forEach(function (stored) {
                if(stored.time === endDate) {
                  stored[item.team].forEach(function (subItem) {
                    if(item.action === "Kiállítás" && subItem.excluded && subItem.excluded.id === item.excluded.id){ storedYet = true; }
                    if(item.action === "Hivatalos Kiállítás" && subItem.down.id === item.down.id){ storedYet = true; }
                  });
                }
              });

              if(!storedYet) {
                if(self.restoreDialog.time === endDate) {
                  self.restoreDialog.teams[item.team].forEach(function (subItem) {
                    if(item.action === "Kiállítás" && subItem.excluded && subItem.excluded.id === item.excluded.id){ storedYet = true; }
                    if(item.action === "Hivatalos Kiállítás" && subItem.down.id === item.down.id){ storedYet = true; }
                  });
                }
              }

              if(!storedYet) {
                let saveRestoreParams = {
                  up: null,
                  down: item.down,
                  excluded: item.excluded ? item.excluded : null,
                  selected: item.excluded ? item.excluded : item.down,
                };

                if(self.storeExcludes.length && self.storeExcludes[self.storeExcludes.length-1].time === endDate) {
                  let lastStored = self.storeExcludes[self.storeExcludes.length-1];
                  self.storeExcludes[self.storeExcludes.length-1] = {
                    A: lastStored['A'],
                    B: lastStored['B'],
                    [item.team]: [...lastStored[item.team], saveRestoreParams],
                    time: endDate,
                    // JAVÍTÁS: createdSeconds (item.time-ból) már abszolút idő, nem kell
                    // még egyszer hozzáadni a félidő-kezdetet (ld. a CLOCK.TICK handler
                    // elején lévő azonos hiba magyarázatát).
                    totalGameTime: createdSeconds + durationSeconds,
                  };
                } else {
                  self.storeExcludes.push({
                    A: [],
                    B: [],
                    [item.team]: [saveRestoreParams],
                    time: endDate,
                    // JAVÍTÁS: createdSeconds (item.time-ból) már abszolút idő, nem kell
                    // még egyszer hozzáadni a félidő-kezdetet (ld. a CLOCK.TICK handler
                    // elején lévő azonos hiba magyarázatát).
                    totalGameTime: createdSeconds + durationSeconds,
                  });
                }
              }
            }
          }
        }
      });

      let localGameData = Object.assign({}, self.gamedata);
      let needChange = false;

      ['team_a_players', 'team_b_players'].forEach(function (team) {
        let teamPlayers = [];
        self.gamedata[team].forEach(function (player) {
          teamPlayers.push({
            ...player,
            disabled: passivePeriod || playersHasAction[team].includes(player.id),
          });
          if(!needChange && player.disabled !== (passivePeriod || playersHasAction[team].includes(player.id))) {
            needChange = true;
          }
        });
        localGameData[team] = teamPlayers;
      });

      if(needChange) {
        eventBus.$emit(CONSTANTS.EVENTS.SET.GAMEDATA, localGameData);
      }

      self.time = newFixedTime;

      // --- ITT FRISSÜL A PÁLYÁN TÖLTÖTT IDŐ ---
      if (window.stopwatch) {
        let uniqueEvents = [...self.allItems];
        self.timelineData.forEach(localItem => {
          // 79. tétel: az előző félidőből átvitt kiállítás rejtett másolata
          // ugyanazt a UUID-t viseli, de az aktuális periódussal - ha felülírná
          // az eredetit, a kijelzett játékidő az előző félidőt a végéig számolná.
          if (localItem.hidden) return;
          const index = uniqueEvents.findIndex(i => i.UUID === localItem.UUID);
          if (index !== -1) { uniqueEvents[index] = localItem; } else { uniqueEvents.push(localItem); }
        });
        let calculatedTotalTime = currentAbsoluteSeconds;
        self.calculatePlaytime({
          items: uniqueEvents,
          currentTotalTime: calculatedTotalTime,
          currentPeriod: self.actualPeriod,
          saveToDb: false
        });
      }

      if(!self.restoreDialog.show && self.storeExcludes.length) {
        self.$nextTick(() => {
          if (self.storeExcludes.length > 0) {
            self.setExcludesDialog(self.storeExcludes[0]);
            self.storeExcludes.shift();
          }
        });
      }
    });
    // -------------------------------------------------------------

    this.$busOn(CONSTANTS.EVENTS.TIMELINE.ITEM.CLOSE, function (element) {
      let timelineTable = [];
      let editedTable = [];
      let userCan = true;

      self.editingTimeline.forEach(function (item) {
        if (item.UUID !== element.UUID) {
          editedTable.push(item);
        } else {
          let teamText = self.getTeamKey(item.team);
          if(item.action === 'Felmegy') self.setPlayer('playing', false, item.up.id, teamText);
          if(item.action === 'Csere') {
            if (item.up) self.setPlayer('selected', false, item.up.id, teamText);
            if (item.down) self.setPlayer('selected', false, item.down.id, teamText);
          }
        }
      });

      self.timelineData.forEach(function (item) {
        if (item.UUID !== element.UUID) {
          timelineTable.push(item);
        } else {
          timelineTable.push({...item, editing: false, isNew: false});
          let teamText = self.getTeamKey(item.team);
          if(item.action === 'Felmegy') self.setPlayer('playing', true, item.up.id, teamText);
          if(item.action === 'Csere') {
            if(!self.getPlayer(item.up.id, teamText).playing && self.getPlayer(item.down.id, teamText).playing && !self.getPlayer(item.up.id, teamText).excluded && !self.getPlayer(item.down.id, teamText).excluded) {
              self.setPlayer('playing', false, item.down.id, teamText);
              self.setPlayer('playing', true, item.up.id, teamText);
            } else {
              userCan = false;
            }
          }
        }
      });

      if(userCan) {
        self.timelineData = timelineTable;
        self.editingTimeline = editedTable;
      } else {
        self.showAlert();
      }
    });
    this.$busOn(CONSTANTS.EVENTS.TIMELINE.ITEM.SAVE.ALL, function () {
      let editedTable = [];
      self.editingTimeline.forEach(function (item) {
        if ((item.action === "Csere" && item.up && item.down) ||
            (item.action === "Kiállítás" && item.down && item.excluded) ||
            (item.action === "Hivatalos Kiállítás" && item.down) ||
            (item.action === "Felmegy" && item.up)) {
          let players = {
            up: item.up ? item.up : null,
            down: item.down ? item.down : null,
            excluded: item.excluded ? item.excluded : null,
          };
          eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.SAVE.ONE, item.UUID, players, item.team, false);
        } else {
          editedTable.push(item);
        }
      });
      self.editingTimeline = editedTable;
    });
    this.$busOn(CONSTANTS.EVENTS.TIMELINE.ITEM.SAVE.ONE, function (UUID, players, team, alone) {
      let timelineTable = [];
      let editedTable = [];
      let teamText = self.getTeamKey(team);

      if(players.down) self.setPlayer('playing', false, players.down.id, teamText);
      if(players.up) self.setPlayer('playing', true, players.up.id, teamText);
      if(players.up && players.down) {
        self.setPlayer('selected', false, players.up.id, teamText);
        self.setPlayer('selected', false, players.down.id, teamText);
      }

      timelineTable = self.timelineData.filter(function (item) {
        return item.UUID !== UUID;
      });

      self.editingTimeline.forEach(function (item) {
        if (item.UUID !== UUID) {
          editedTable.push(item);
        } else {
          debug({...item, editing: false, isNew: false});
          let updated = {...item, editing: false, isNew: false};
          if (item.isNew) {
            self.createEvent(updated);
          } else {
            self.updateEvent(updated);
          }
          timelineTable.push(updated);
        }
      });

      if(alone) {
        self.editingTimeline = editedTable;
      }
    });

    // --- JAVÍTÁS: Periódus váltás vs RC megkülönböztetése ---
    this.$busOn(CONSTANTS.EVENTS.PERIOD.CHANGED.SUBSTITUTE, function (period) {
      self.allItems = self.allItems.filter(function (item) {
        return item.period !== self.actualPeriod;
      });
      self.timelineData.forEach(function (item) {
        if(!item.hidden) {
          let newAllItems = [...self.allItems, {...item, editing: false, isNew: false}];
          self.allItems = newAllItems;
        }
      });

      // Ha az új periódus (pl. "2") KÜLÖNBÖZIK a jelenlegitől ("1"), akkor ez egy VÁLTÁS -> NEM őrzünk állapotot (preserve=false), hogy jöhessen a kezdőcsapat választás.
      // Ha az új periódus ("1") MEGEGYEZIK a jelenlegivel ("1"), akkor ez egy RC -> Őrizzük meg az állapotot (preserve=true).
      let preserve = (String(period) === String(self.actualPeriod)) && self.gameStarted;

      self.loadPeriod(self.allItems, period, preserve);

      self.calculatePlaytime({
        items: self.allItems,
        currentPeriod: period,
        currentTotalTime: window.stopwatch.getTotalTime(),
        saveToDb: true
      });
    });
    // --------------------------------------------------------

    this.$busOn(CONSTANTS.EVENTS.CLOCK.CHANGED, function (newTime) {
      let timelineTable = [];
      self.timelineData.forEach(function (item) {
        timelineTable.push({...item, editing: false, isNew: false});
      });
      self.timelineData = timelineTable;
      self.editingTimeline = [];
      self.loadStatusToTime(newTime);
    });
    this.$busOn(CONSTANTS.EVENTS.PERIOD.ENDS, function () {
      // 1. Meglévő logika: Adatok mentése és játékidő számolás
      let storedItems = self.allItems.filter(function (item) {
        return item.period !== self.actualPeriod;
      });
      self.timelineData.forEach(function (item) {
        if(!item.hidden) {
          storedItems.push(item);
        }
      });
      self.allItems = storedItems;
      self.calculatePlaytime({
        items: self.allItems,
        currentPeriod: self.actualPeriod,
        currentTotalTime: window.stopwatch.getTotalTime(),
        saveToDb: true
      });

      // 2. ÚJ RÉSZ: Beküldő ablak (GameFinishDialog) megjelenítése
      // Ha a 2. félidő (normál vége) vagy a 4. félidő (hosszabbítás vége) járt le:
      if (['2', '4'].includes(String(self.actualPeriod))) {
        console.log(`[Substitute] Mérkőzés vége (Period ${self.actualPeriod}). Beküldés ablak nyitása.`);

        // Frissítjük a statisztikákat a Store-ban, ahogy a ReportScreen is teszi
        self.$store.dispatch('game/recalculateDrafts');
        self.$store.dispatch('game/recalculateRejecteds');

        // Kinyitjuk a modalt a UI Store-on keresztül
        self.$store.commit('ui/SET_GAMEFINISHDIALOG', true);

        // Opcionális: Bezárjuk az oldalmenüt, ha nyitva lenne
        self.$store.commit('ui/SET_SHOW_MENU', false);
      }
    });
    this.$busOn(CONSTANTS.EVENTS.ALERTBOX, function (text) {
      self.showAlert(text);
    });
    this.$busOn(CONSTANTS.EVENTS.MATCH.START, function () {
      self.gameStarted = true;
      eventBus.$emit(CONSTANTS.EVENTS.CLOCK.DISABLE, false);
      eventBus.$emit(CONSTANTS.EVENTS.CLOCK.SETTINGSDISABLE, false);

      let startSeconds = self.getPeriodStartTime(self.actualPeriod);
      let startTimeString = TimeFormatter.intToString(startSeconds);

      ['A', 'B'].forEach(function (team) {
        self.gamedata[self.getTeamKey(team)].forEach(function (player) {
          if (player.playing) {
            self.createEvent({
              UUID: window.dbmanager.generateUUID(),
              team: team,
              up: { id: player.id, jersey: player.jersey, name: player.name },
              down: null,
              excluded: null,
              action: 'Kezdőjátékos',
              time: startTimeString,
              totalGameTime: startSeconds,
              period: self.actualPeriod,
              editing: false,
              isNew: false,
            });
          }
        });
      });
      window.dbmanager.sync();
    });
  },
  mounted() {
    this.initSubstituteData({
      substituteTimeline: this.substituteTimeline,
      period: this.actualPeriod
    });
    if (this.allItems && this.allItems.length > 0) {
      //this.loadPeriod(this.allItems, this.actualPeriod);
    }
  },
  methods: {
    ...mapActions('substitute', ['initSubstituteData', 'calculatePlaytime', 'createEvent', 'deleteEvent', 'updateEvent', 'saveEvents']),
    ...mapMutations('substitute', ['SET_TIMELINE_DATA', 'SET_ALL_ITEMS', 'SET_OFFICIAL_EXCLUDES', 'SET_CURRENT_PERIOD']),
    ...mapMutations('game', ['SET_PERIOD']),


    handleSpace(event) {
      if (event) event.preventDefault();
      if (this.gamefinished) return;
      if (this.isPassivePeriod(this.actualPeriod)) {
        this.showAlert("Szünetben az óra nem indítható a Csere felületről!");
        return;
      }
      debug("Space gomb lenyomva - Óra kapcsolása");
      eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.PAUSE);
    },

    showAlert(text) {
      let self = this;
      if(!self.alertBox) {
        self.alertBox = true;
        if(text) {
          self.alertText = text;
        } else {
          self.alertText = "A kívánt interakció nem megvalósítható, mert egy másik esemény már épít rá!";
        }
        window.setTimeout(() => {
          self.alertBox = false;
          self.alertText = '';
        }, 3500);
      }
    },
    officialExclude (team) {
      eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEPLAYERDIALOG, null, team, 1);
    },
    officialExcludeDouble (team) {
      eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEPLAYERDIALOG, null, team, 1);
    },
    officialCancel (item, team) {
      let self = this;
      let teamText = self.getTeamKey(team);
      let playerData = self.getPlayer(item.downId, teamText);
      let player = { id: playerData.id, jersey: playerData.jersey, name: playerData.name };
      eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEOFFICIAL, false, player, team, item);
    },
    handleScroll () {
      let self = this;
      let element = self.$el.querySelector(".midContent");
      if(element.scrollTop >= (element.scrollHeight - element.offsetHeight)) {
        if(self.timelineItems.length > self.lazyLoadItems) {
          self.lazyLoadItems += 20;
        }
      }
    },
    getExcludedItem (upItem) {
      let self = this;
      let rtn = false;
      // JAVÍTÁS (79. tétel): a "Felmegy" párja az a kiállítás, amelyiknek a
      // VÉGE (kezdet + saját időtartam) egyezik a visszatérés idejével. Korábban
      // fix 120 mp-et vontunk le, így egy 2+2 perces (04:00) kiállítás párját
      // sosem találta meg. Ha időtartam-alapon nincs találat, a régi, 120 mp-es
      // egyezést is megpróbáljuk (régi adatok).
      let upSeconds = TimeFormatter.stringToInt(upItem.time);
      let legacyTime = TimeFormatter.intToString(upSeconds - 120);
      const matches = function (item) {
        if(item.action === "Kiállítás" && item.excluded && upItem.excluded && item.excluded.id === upItem.excluded.id) return true;
        if(item.action === "Hivatalos Kiállítás" && item.down && upItem.down && item.down.id === upItem.down.id) return true;
        return false;
      };
      self.timelineData.find(function (item) {
        if (!matches(item)) return false;
        let itemEnd = TimeFormatter.stringToInt(item.time) + TimeFormatter.stringToInt(item.duration ?? '02:00');
        if (itemEnd === upSeconds) { rtn = item; return true; }
        return false;
      });
      if (!rtn) {
        self.timelineData.find(function (item) {
          if(item.time === legacyTime && matches(item)) { rtn = item; return true; }
          return false;
        });
      }
      return rtn;
    },
    // JAVÍTÁS (79. tétel): az előző félidőből átnyúló kiállítás a loadPeriod-ban
    // egy rejtett (hidden) másolatként kerül az aktuális periódus listájába.
    // Régen negatív, periódus-relatív idővel ("-03:16") került be, és a kód ezt
    // az `item.time < '00:00'` feltétellel ismerte fel - az óra viszont 2026-07
    // óta abszolút időt ad (l. CLOCK.TICK), ezért most az eredeti, abszolút
    // kezdési idővel kerül be. A felismerés a `hidden` jelzőn alapul, a negatív
    // idő csak a régi formátum miatt maradt benne.
    isCarriedExclude (item) {
      return !!item && ["Kiállítás", "Hivatalos Kiállítás"].includes(item.action) &&
          (item.hidden === true || (typeof item.time === 'string' && item.time.charAt(0) === '-'));
    },
    // Egy "Felmegy", amelyik egy előző félidőből átnyúló kiállítást zár le.
    isCarriedRestore (item) {
      if (!item || item.action !== 'Felmegy') return false;
      let excludedItem = this.getExcludedItem(item);
      return !!excludedItem && this.isCarriedExclude(excludedItem);
    },
    getExcludedName (player, team) {
      let self = this;
      let playerId = player.id ? player.id : player;
      let teamText = self.getTeamKey(team);
      let obj = self.getPlayer(playerId, teamText);
      return obj.jersey + ' ' + obj.name;
    },
    teamNamesAndPlayersNumber () {
      let self = this;
      let team = {
        'A': !self.isMirrored ? 'A' : 'A',
        'B': !self.isMirrored ? 'B' : 'B',
      };
      return {
        [team['A']]: {
          name: self.gamedata['team_a_name'],
          active: self.activePlayersNumber('A'),
          maxPlayers: self.maxActivePlayers - self.getExcludedPlayers('A'),
        },
        [team['B']]: {
          name: self.gamedata['team_b_name'],
          active: self.activePlayersNumber('B'),
          maxPlayers: self.maxActivePlayers - self.getExcludedPlayers('B'),
        }
      };
    },
    activePlayersNumber: function (team) {
      let self = this;
      let rtn = 0;
      let teamText = self.getTeamKey(team);
      if (self.gamedata[teamText]) {
        self.gamedata[teamText].forEach(function (player) {
          if (player.playing && !player.excluded) {
            rtn++;
          }
        });
      }
      return rtn;
    },
    getExcludedPlayers: function (team) {
      let self = this;
      let rtn = 0;
      let teamText = self.getTeamKey(team);
      if (self.gamedata[teamText]) {
        self.gamedata[teamText].forEach(function (player) {
          if(player.excluded) {
            rtn++;
          }
        });
      }
      return rtn + self.officialExcludes[team].length;
    },
    getPlayer: function (id, team) {
      return this.getPlayerById(id);
    },
    setPlayer: function (key, value, id, team) {
      let self = this;
      let index = self.getIndex(self.gamedata[team], id);
      let newData = Object.assign({}, self.gamedata);
      newData[team][index][key] = value;
      eventBus.$emit(CONSTANTS.EVENTS.SET.GAMEDATA, newData);
    },
    getIndex: function (data, id) {
      let result = false;
      data.forEach(function (item, index) {
        if (item.id === id) {
          result = index;
        }
      });
      return result;
    },
    isActiveExclude: function (start, duration, end) {
      let startSecond = TimeFormatter.stringToInt(start);
      let durationSecond = TimeFormatter.stringToInt(duration);
      let endSecond = TimeFormatter.stringToInt(end);
      return ((startSecond + durationSecond) >= endSecond) && (startSecond <= endSecond);
    },
    canActionDelete: function(item) {
      let self = this;
      let emptyGoalkeeper = true;
      let teamText = self.getTeamKey(item.team);
      let downPlayer = self.getPlayer(item.down.id, teamText);
      if(downPlayer.goalkeeper) {
        self.gamedata[teamText].forEach(function (player) {
          if(emptyGoalkeeper && player.goalkeeper && player.playing && player.id !== item.up.id) {
            emptyGoalkeeper = false;
          }
        });
      }
      return emptyGoalkeeper;
    },
    timeGroupTable: function (table) {
      let self = this;
      let timeGroupedList = [];
      let orderedTable = [...table].sort(self.compareInc);
      orderedTable.forEach(function (item, index) {
        let newItem = true;
        let count = 0;
        if (index > 0 && orderedTable[index - 1].time === item.time) newItem = false;
        if (newItem) {
          timeGroupedList.push({time: item.time, [item.team]: [item]});
        } else {
          count = timeGroupedList.length - 1;
          if (timeGroupedList[count][item.team]) {
            timeGroupedList[count][item.team].push(item);
          } else {
            timeGroupedList[count][item.team] = [item];
          }
        }
      });
      return timeGroupedList;
    },
    isEditing: function (table) {
      let newItem = true;
      table.forEach(function (item) {
        if (item.editing) newItem = false;
      });
      return !newItem
    },
    localClearPlayers: function (disabled) {
      let self = this;
      let localGameData = Object.assign({}, self.gamedata);
      ['team_a_players', 'team_b_players'].forEach(function (team) {
        let teamPlayers = [];
        if (localGameData[team]) {
          localGameData[team].forEach(function (player) {
            teamPlayers.push({
              ...player,
              selected: false,
              playing: false,
              excluded: false,
              disabled: Boolean(disabled),
              remainingExclude: '',
            });
          });
          localGameData[team] = teamPlayers;
        }
      });
      return localGameData;
    },
    compareInc: function (a, b) {
      if (a.time < b.time) return -1;
      if (a.time > b.time) return 1;
      return 0;
    },
    compareDesc: function (a, b) {
      if (a.time < b.time) return 1;
      if (a.time > b.time) return -1;
      return 0;
    },
    existGoalkeeper: function (team) {
      let self = this;
      let rtn = false;
      if(self.gamedata[team]) {
        self.gamedata[team].forEach(player => {
          if(player.playing && player.goalkeeper) rtn = true;
        });
      }
      return rtn;
    },
    canGoalkeeper: function (players, isGoalkeeper, status) {
      let playerInAction = 0;
      if (isGoalkeeper) {
        players.forEach(player => {
          if (player.goalkeeper && player[status]) playerInAction++;
        });
      }
      return !playerInAction;
    },
    loadInteractions: function (gamedata, time) {
      let self = this;
      let timeGroupedList = self.timeGroupTable(self.timelineData);
      let localGameData = {...gamedata};
      timeGroupedList.forEach(function (timeItems) {
        ['A', 'B'].forEach(function (team) {
          if (timeItems[team]) {
            let interactions = [];
            timeItems[team].forEach(function (item) {
              if (item.time <= time) interactions.push(item);
            });
            localGameData = self.multipleInteractions(interactions.sort(self.actionCompareInc), localGameData, time);
          }
        });
      });
      eventBus.$emit(CONSTANTS.EVENTS.SET.GAMEDATA, localGameData);
    },
    multipleInteractions: function (table, gamedata, time) {
      let self = this;
      let leftItems = [];
      let localGameData = {...gamedata};
      table.forEach(function (item) {
        let teamText = self.getTeamKey(item.team);
        item.duration = item.duration ?? "02:00";
        if (item.action === "Kezdőjátékos") {
          let playerIndex = self.getIndex(localGameData[teamText], item.up.id);
          if (!localGameData[teamText][playerIndex].playing) localGameData[teamText][playerIndex].playing = true;
        }
        if (item.action === "Felmegy") {
          let playerIndex = self.getIndex(localGameData[teamText], item.up.id);
          if (!localGameData[teamText][playerIndex].playing && !localGameData[teamText][playerIndex].excluded) {
            localGameData[teamText][playerIndex].playing = true;
          } else {
            leftItems.push(item);
          }
        }
        if (item.action === 'Csere') {
          let playerUpIndex = self.getIndex(localGameData[teamText], item.up.id);
          let playerDownIndex = self.getIndex(localGameData[teamText], item.down.id);
          if (!localGameData[teamText][playerUpIndex].playing && localGameData[teamText][playerDownIndex].playing && !localGameData[teamText][playerUpIndex].excluded && !localGameData[teamText][playerDownIndex].excluded) {
            localGameData[teamText][playerUpIndex].playing = true;
            localGameData[teamText][playerDownIndex].playing = false;
          } else {
            leftItems.push(item);
          }
        }
        if (item.action === "Kiállítás") {
          let playerDownIndex = self.getIndex(localGameData[teamText], item.down.id);
          let playerExcludedIndex = self.getIndex(localGameData[teamText], item.excluded.id);
          if ((localGameData[teamText][playerDownIndex].playing || self.isCarriedExclude(item)) && (!localGameData[teamText][playerDownIndex].excluded || item.down.id === item.excluded.id)) {
            localGameData[teamText][playerDownIndex].playing = false;
            if(self.isActiveExclude(item.time, item.duration, time)) {
              if(TimeFormatter.stringToInt(item.time) + TimeFormatter.stringToInt(item.duration) < TimeFormatter.stringToInt(time)) {
                localGameData[teamText][playerExcludedIndex].excluded = true;
              }
            }
          }
        }
        if (item.action === "Hivatalos Kiállítás") {
          let playerDownIndex = self.getIndex(localGameData[teamText], item.down.id);
          if ((localGameData[teamText][playerDownIndex].playing || self.isCarriedExclude(item)) && !localGameData[teamText][playerDownIndex].excluded) {
            localGameData[teamText][playerDownIndex].playing = false;
            if(self.isActiveExclude(item.time, item.duration, time)) {
              if(TimeFormatter.stringToInt(item.time) + TimeFormatter.stringToInt(item.duration) < TimeFormatter.stringToInt(time)) {
                let newOfficialExcludes = {...self.officialExcludes};
                newOfficialExcludes[item.team].push({
                  UUID: item.UUID,
                  downId: localGameData[teamText][playerDownIndex].id,
                  remainingExclude: '',
                });
                self.officialExcludes = newOfficialExcludes;
              }
            }
          }
        }
      });
      if (leftItems.length) {
        if(table.length === leftItems.length) { debug("loop!"); } else {
          localGameData = self.multipleInteractions(leftItems, localGameData, time);
        }
      }
      return localGameData;
    },
    multipleInteractionDelete: function (actualTime, table, excludeds) {
      let self = this;
      let leftItems = [];
      let excludedItems = excludeds;
      table.forEach(function (item) {
        let teamText = self.getTeamKey(item.team);
        if(actualTime) {
          if (item.action === 'Kiállítás') {
            if (!self.getPlayer(item.down.id, teamText).playing && (!self.getPlayer(item.excluded.id, teamText).excluded || item.excluded.id === item.down.id)) {
              if (self.getPlayer(item.excluded.id, teamText).excluded) {
                self.setPlayer('excluded', false, item.excluded.id, teamText);
                self.setPlayer('remainingExclude', '', item.excluded.id, teamText);
              }
              self.setPlayer('playing', true, item.down.id, teamText);
            } else {
              leftItems.push(item);
            }
          } else if (item.action === 'Hivatalos Kiállítás') {
            if (!self.getPlayer(item.down.id, teamText).playing && !self.getPlayer(item.down.id, teamText).excluded) {
              let currentExcludes = self.officialExcludes[item.team].filter((tmpItem) => { return tmpItem.UUID !== item.UUID; });
              let allExcludes = {...self.officialExcludes};
              allExcludes[item.team] = currentExcludes;
              self.officialExcludes = allExcludes;
              self.setPlayer('playing', true, item.down.id, teamText);
            } else {
              leftItems.push(item);
            }
          } else if (item.action === 'Csere') {
            if (self.getPlayer(item.up.id, teamText).playing && !self.getPlayer(item.down.id, teamText).playing && !self.getPlayer(item.up.id, teamText).excluded && !self.getPlayer(item.down.id, teamText).excluded) {
              self.setPlayer('playing', false, item.up.id, teamText);
              self.setPlayer('playing', true, item.down.id, teamText);
            } else {
              leftItems.push(item);
            }
          } else if (item.action === 'Felmegy') {
            let excludedItem = self.getExcludedItem(item);
            if (self.getPlayer(item.up.id, teamText).playing && !self.getPlayer(item.up.id, teamText).excluded && (!self.getPlayer(excludedItem.down.id, teamText).playing || item.up.id === excludedItem.down.id)) {
              if (item.excluded && self.getPlayer(item.excluded.id, teamText).excluded) {
                self.setPlayer('excluded', false, item.excluded.id, teamText);
                self.setPlayer('remainingExclude', '', item.excluded.id, teamText);
              }
              if(!item.excluded) {
                let currentExcludes = self.officialExcludes[item.team].filter((subItem) => { return subItem.UUID !== excludedItem.UUID; });
                let allExcludes = {...self.officialExcludes};
                allExcludes[item.team] = currentExcludes;
                self.officialExcludes = allExcludes;
              }
              self.setPlayer('playing', false, item.up.id, teamText);
              self.setPlayer('playing', true, excludedItem.down.id, teamText);
              excludedItems.push(excludedItem.UUID);
            } else {
              leftItems.push(item);
            }
          }
        } else {
          if (item.action === 'Felmegy') {
            let excludedItem = self.getExcludedItem(item);
            excludedItems.push(excludedItem.UUID);
          }
        }
      });
      if (leftItems.length) {
        if(table.length === leftItems.length) { debug("loop!"); } else {
          excludedItems.push([...self.multipleInteractionDelete(actualTime, leftItems.sort(self.actionCompareDesc), excludedItems)]);
        }
      }
      return excludedItems;
    },
    actionCompareInc: function (a, b) {
      let order = ["Kezdőjátékos", "Felmegy", "Csere", "Hivatalos Kiállítás", "Kiállítás"];
      if (order.indexOf(a.action) < order.indexOf(b.action)) return -1;
      if (order.indexOf(a.action) > order.indexOf(b.action)) return 1;
      return 0;
    },
    actionCompareDesc: function (a, b) {
      let order = ["Kiállítás", "Hivatalos Kiállítás", "Csere", "Felmegy", "Kezdőjátékos"];
      if (order.indexOf(a.action) < order.indexOf(b.action)) return 1;
      if (order.indexOf(a.action) > order.indexOf(b.action)) return -1;
      return 0;
    },
    maxTeamSize: function () {
      let self = this;
      return Math.max.apply(null, [16, self.gamedata.team_a_players.length, self.gamedata.team_b_players.length]);
    },
    setExcludesDialog: function(data) {
      let self = this;
      self.restoreDialog.teams = { A: data['A'], B: data['B'] };
      ['A', 'B'].forEach(function (team) {
        let teamText = self.getTeamKey(team);
        self.restoreDialog.teams[team].forEach(function (item) {
          if(item.excluded) {
            self.setPlayer('excluded', false, item.excluded.id, teamText);
            self.setPlayer('remainingExclude', '', item.excluded.id, teamText);
          } else {
            let currentExcludes = self.officialExcludes[team].filter((tmpItem) => {
              return tmpItem.downId !== item.down.id;
            });
            let allExcludes = {...self.officialExcludes};
            allExcludes[team] = currentExcludes;
            self.officialExcludes = allExcludes;
          }
        });
      });
      self.restoreDialog.time = data.time;
      self.restoreDialog.totalGameTime = data.totalGameTime;
      self.restoreDialog.show = true;
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, true);
    },
    setPlayersPlaying: function () {
      let self = this;
      self.restoreDialog.show = false;
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);

      if (self.restoreDialog.UUID) {
        let editedTable = [];
        let savePlayer = self.restoreDialog.teams[self.restoreList.A ? 'A' : 'B'][0];
        let playerId = savePlayer.selected;
        if(playerId.id) playerId = playerId.id;

        self.editingTimeline.forEach(function (item) {
          if(item.UUID === self.restoreDialog.UUID) {
            let teamText = self.getTeamKey(item.team);
            let player = self.getPlayer(playerId, teamText);
            self.setPlayer('playing', true, playerId, teamText);
            eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.PLAYER.SELECT, false, player, item.team);
            editedTable.push({
              ...item,
              up: { id: player.id, jersey: player.jersey, name: player.name },
            });
          } else {
            editedTable.push(item);
          }
        });
        self.editingTimeline = editedTable;
      } else {
        ['A', 'B'].forEach(function (team) {
          self.restoreDialog.teams[team].forEach(function (item) {
            let teamText = self.getTeamKey(team);
            let playerId = item.selected;
            let playerDown = item.down;
            if(playerId.id) playerId = playerId.id;

            self.setPlayer('playing', true, playerId, teamText);
            let player = self.getPlayer(playerId, teamText);
            eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.PLAYER.SELECT, false, player, team);

            self.createEvent({
              UUID: window.dbmanager.generateUUID(),
              team: team,
              down: { id: playerDown.id, jersey: playerDown.jersey, name: playerDown.name },
              up: { id: player.id, jersey: player.jersey, name: player.name },
              excluded: item.excluded ? { id: item.excluded.id, jersey: item.excluded.jersey, name: item.excluded.name } : null,
              action: 'Felmegy',
              time: self.restoreDialog.time,
              totalGameTime: self.restoreDialog.totalGameTime,
              period: self.actualPeriod,
              editing: false,
              isNew: false,
            });
          });
        });
      }
      self.restoreDialogDefault();
      if(self.storeExcludes.length) {
        self.setExcludesDialog(self.storeExcludes[0]);
        self.storeExcludes.shift();
      }
    },
    restoreDialogDefault: function(restorePlayer) {
      let self = this;
      if(restorePlayer) {
        let player = {};
        let team = '';
        if(self.restoreList.A) {
          player = self.restoreDialog.teams.A[0].up;
          team = 'A';
        }
        if(self.restoreList.B) {
          player = self.restoreDialog.teams.B[0].up;
          team = 'B';
        }
        if(self.restoreList.A || self.restoreList.B) {
          let teamText = self.getTeamKey(team);
          self.setPlayer('playing', true, player.id, teamText);
        }
      }
      self.restoreDialog = {
        show: false,
        teams: { A: [], B: [] },
        UUID: null,
        time: '00:00',
        totalGameTime: 0
      };
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
    },
    singleExcludeDialogDefault: function() {
      let self = this;
      self.singleExcludeDialog = {
        show: false,
        selected: null,
        player: {},
        team: '',
        time: '00:00',
      };
      eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
    },
    saveExcludeItem: function () {
      let self = this;
      if (self.singleExcludeDialog.type === 1) {
        if (self.singleExcludeDialog.player) {
          eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEPLAYER, true, self.singleExcludeDialog.player, self.singleExcludeDialog.team, self.singleExcludeDialog.selected);
        } else {
          eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEOFFICIAL, true, self.singleExcludeDialog.selected, self.singleExcludeDialog.team);
        }
      } else {
        console.log("kettes");
      }
      self.singleExcludeDialogDefault();
    },
// --- 1. SEGÉDFÜGGVÉNY RENDEZÉSHEZ ---
    previousItemSort: function(a, b) {
      if (a.totalGameTime < b.totalGameTime) return -1;
      if (a.totalGameTime > b.totalGameTime) return 1;
      let aClient = a.clientTime || 0;
      let bClient = b.clientTime || 0;
      if (aClient < bClient) return -1;
      if (aClient > bClient) return 1;
      return 0;
    },

    // --- 2. JAVÍTOTT LOADSTATUS (Zöld ikon hiba javítása) ---
    loadStatusToTime: function (time) {
      let self = this;

      // 1. LÉPÉS: Tiszta lap (Mindenki a kezdőbe/padra a start lista alapján)
      let gamedata = self.localClearPlayers(true);

      // 2. LÉPÉS: A "Múlt" felépítése (Hogy tudjuk, ki jött ki a 3. félidőre)
      // Csak a KORÁBBI periódusok eseményeit gyűjtjük ki
      const isStrand = self.$store.state.game.gamedata && self.$store.state.game.gamedata.rule === 'STRAND';
      // JAVÍTÁS (TELJESÍTMÉNY): a modul-feloldás kiemelve, mert lentebb egy
      // szűrőben (elemenként) ÉS egy rendezés komparátorában
      // (összehasonlításonként kétszer) is hívtuk - felesleges, ismételt
      // modul-lookup minden egyes periódus-váltásnál/újratöltésnél.
      const getChronoOrder = require('@/utils/periodOrder').getChronoOrder;
      const actualChrono = getChronoOrder(self.actualPeriod, isStrand);

      // JAVÍTÁS (2026-08-31, "9 fő a pályán" hiba): a "Kezdőjátékos" akció a
      // multipleInteractions-ben CSAK hozzáad (playing=true), SOHA nem vesz el
      // senkit. Ha a jelenlegi periódusnak MÁR VAN saját, korábban elmentett
      // kezdőcsapata, és a felhasználó utólag VISSZAMEGY egy korábbi
      // periódusra és ott módosít valamit (csere, kiállítás), a lenti "Múlt"
      // réteg a MÓDOSÍTOTT, friss állapotot adná (helyesen) - DE ha erre
      // MÉG RÁKERÜLNE a jelenlegi periódus RÉGI, elavult "Kezdőjátékos"
      // batch-e is (mert az korábban, egy MÁS pillanatban lett elmentve),
      // a benne szereplő, azóta már lecserélt/kiállított játékosok
      // VISSZAKERÜLNÉNEK a pályára, RÁHALMOZÓDVA a friss, helyes létszámra
      // (pl. 7 helyett 9 fő). A "Múlt" réteg ezért csak akkor szolgáljon
      // alapállapotként, ha a jelenlegi periódusnak MÉG NINCS saját
      // kezdőcsapata - ha már van, a playing-állapotot kizárólag a
      // jelenlegi periódus saját eseménysorából kell felépíteni (ezt a
      // loadInteractions() lentebb, a 3. lépésben úgyis elvégzi).
      const hasOwnStartingLineup = self.allItems && self.allItems.some(item =>
          item.period === self.actualPeriod && item.action === 'Kezdőjátékos' && !item.deleted
      );

      if (actualChrono > 1 && !hasOwnStartingLineup && self.allItems && self.allItems.length > 0) {
        let historyEvents = self.allItems.filter(item => {
            const itemChrono = getChronoOrder(item.period, isStrand);
            return itemChrono < actualChrono && !item.deleted;
        });

        if (historyEvents.length > 0) {
          // Sorba rendezzük: Először Period 1, aztán Period 2...
          historyEvents.sort((a, b) => {
            let pA = getChronoOrder(a.period, isStrand);
            let pB = getChronoOrder(b.period, isStrand);
            if (pA !== pB) return pA - pB;
            return self.previousItemSort(a, b);
          });

          // Lefuttatjuk a múltat a végtelenbe ('999999'), így beáll a pontos kezdőállapot
          gamedata = self.multipleInteractions(historyEvents, gamedata, '999999');
        }
      }

      // 3. LÉPÉS: A "Jelen" rátöltése
      // Most már csak a jelenlegi periódus eseményeit kell nézni az adott időpontig
      self.loadInteractions(gamedata, time);

      self.$nextTick(() => {
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.TICK, time);
      });
    },

    // --- 2. LOADPERIOD: Betöltéskor/Socket eseménykor hívódik ---
    loadPeriod: function (table, period, preserveClock = false) {
      let self = this;

      // 1. BIZTONSÁGI MENTÉS: Kimentjük az állapotot, mielőtt bármihez nyúlnánk
      let memoryStopwatch = self.lastKnownStopwatch;
      let memoryRunning = self.wasRunning;


      // --- RC DETEKTÁLÁS (VÉDELEM) ---
      // Ha resetet kérnek, de a periódus azonos ÉS van memóriánk -> Ez RC!
      if (!preserveClock && String(self.actualPeriod) === String(period)) {
        if (memoryStopwatch > 0) {
          preserveClock = true;
        }
      }

      // --- RESET LOGIKA (F5 vagy Új Periódus) ---
      if (!preserveClock) {
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.STOP);
        if (window.stopwatch) window.stopwatch.stop();

        // Csak akkor nullázunk, ha ez TÉNYLEG reset (nem RC)
        self.lastKnownStopwatch = 0;
        self.wasRunning = false;
      }

      let passivePeriod = self.isPassivePeriod(period);
      let tempTable = (table && !passivePeriod) ? table : [];

      self.editingTimeline = [];

      if (!preserveClock) {
        self.gameStarted = false;
      }

      self.actualPeriod = period;
      self.SET_CURRENT_PERIOD(period);
      self.SET_PERIOD(period);
      self.officialExcludes = { A: [], B: [] };

      // 1. TISZTA LAP
      let gamedata = self.localClearPlayers(passivePeriod);

      // 2. ELŐZMÉNYEK VISSZAJÁTSZÁSA (Periódusról periódusra)
      const isStrand = self.$store.state.game.gamedata && self.$store.state.game.gamedata.rule === 'STRAND';
      // JAVÍTÁS (TELJESÍTMÉNY): l. a loadStatusToTime azonos javítását - a
      // modul-feloldás kiemelve a lenti szűrőből és rendezés-komparátorból.
      const getChronoOrder = require('@/utils/periodOrder').getChronoOrder;
      const periodChrono = getChronoOrder(period, isStrand);

      // JAVÍTÁS (2026-08-31): l. loadStatusToTime() azonos javítása - ha az
      // ÚJ periódusnak MÁR VAN saját, korábban elmentett kezdőcsapata, a
      // "Múlt" (korábbi periódusok) réteget NEM szabad alapállapotként
      // használni, mert a "Kezdőjátékos" akció sosem vesz el senkit, és az
      // elavult kezdőcsapat-batch a friss, közben módosult előzményekre
      // RÁHALMOZÓDVA hibás (túl sok fős) létszámot adna.
      const hasOwnStartingLineup = self.allItems && self.allItems.some(item =>
          item.period === period && item.action === 'Kezdőjátékos' && !item.deleted
      );

      if (periodChrono > 1 && !hasOwnStartingLineup && self.allItems && self.allItems.length > 0) {
        let historyEvents = self.allItems.filter(item => {
            const itemChrono = getChronoOrder(item.period, isStrand);
            return itemChrono < periodChrono && !item.deleted;
        });
        if (historyEvents.length > 0) {
          historyEvents.sort((a, b) => {
            let pA = getChronoOrder(a.period, isStrand);
            let pB = getChronoOrder(b.period, isStrand);
            if (pA !== pB) return pA - pB;
            if (typeof self.previousItemSort === 'function') return self.previousItemSort(a, b);
            return (a.totalGameTime - b.totalGameTime);
          });
          gamedata = self.multipleInteractions(historyEvents, gamedata, '999999');
        }
      }

      if (!preserveClock) {
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.DISABLE, true);
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.SETTINGSDISABLE, true);
      }

      let startSeconds = self.getPeriodStartTime(period);
      let lastTime = TimeFormatter.intToString(startSeconds);

      if (tempTable.length) {
        tempTable = tempTable.filter(function (item) {
          return item.period === period && !item.deleted;
        });
      }

      let itemFromPeriod = tempTable.length;

      if (itemFromPeriod) {
        self.gameStarted = true;

        let minuteFixedList = [];
        tempTable.forEach(function (item) {
          item.time = TimeFormatter.fixFormat(item.time);
          minuteFixedList.push(item);
        });

        tempTable = [...minuteFixedList].sort(self.compareDesc);

        if (!preserveClock) {
          eventBus.$emit(CONSTANTS.EVENTS.CLOCK.DISABLE, false);
          eventBus.$emit(CONSTANTS.EVENTS.CLOCK.SETTINGSDISABLE, false);
        }

        // --- IDŐ LOGIKA (RC vs F5) ---
        if (preserveClock) {
          // === RC ÁG (Memória használata) ===
          let currentStopwatch = TimeFormatter.stringToInt(window.stopwatch.getTotalTimeAsString());

          // JAVÍTÁS: A legnagyobb értéket használjuk!
          // Ha a stopper újraindult (pl. 3mp), de a memória 1000mp, akkor az 1000-et használjuk.
          let bestTime = Math.max(currentStopwatch, memoryStopwatch);

          // Frissítjük a globális változót a legjobbra
          self.lastKnownStopwatch = bestTime;

          // JAVÍTÁS: bestTime (getTotalTimeAsString()-ból) már abszolút idő, nem kell
          // még egyszer hozzáadni a félidő-kezdetet.
          let calcTimeSeconds = bestTime;

          // Esemény szinkronizáció
          let latestEventTime = tempTable.length > 0 ? tempTable[0].time : "00:00";
          let latestEventSeconds = TimeFormatter.stringToInt(latestEventTime);
          let eventAbsoluteSeconds = latestEventSeconds;
          if (latestEventSeconds < startSeconds) {
            eventAbsoluteSeconds = latestEventSeconds + startSeconds;
          }

          // Ha az esemény ideje NAGYOBB, mint a számított idő (tehát előrébb van), akkor odaugrunk.
          // Egyébként maradunk a számított időnél (hogy ne ugorjon vissza).
          if (eventAbsoluteSeconds > calcTimeSeconds) {
            lastTime = TimeFormatter.intToString(eventAbsoluteSeconds);
          } else {
            lastTime = TimeFormatter.intToString(calcTimeSeconds);
          }
        } else {
          // === F5 ÁG (Nincs memória) ===
          if (tempTable.length > 0) {
            lastTime = tempTable[0].time;
          }
        }
      }

      let currentPeriodData = self.getPeriodData(self.actualPeriod);
      let previousPeriod = currentPeriodData.previousValue ? self.getPeriodData(currentPeriodData.previousValue) : {};
      if(previousPeriod.previousValue && !previousPeriod.duration) {
        previousPeriod = self.getPeriodData(previousPeriod.previousValue);
      }

      if (previousPeriod.value) {
        // JAVÍTÁS (79. tétel - 32021422379): az előző félidőből átnyúló
        // kiállítások átvitele. Korábban a kiállítás periódus-relatív, negatív
        // idővel került át ("-03:16" = 3:16-tal a félidő vége előtt), és a
        // hátralévő időt is a lastTime-hoz mérte - csakhogy 2026-07 óta minden
        // idő (óra, lastTime, események) a meccs elejétől mért abszolút idő. A
        // keveredés miatt:
        //  - a visszatérés ("Felmegy") vége -196 + 240 = 44 mp lett, vagyis
        //    "00:44"/44 a helyes "30:44"/1844 helyett, és a visszatérés-ablak a
        //    II. félidő első másodpercében felugrott;
        //  - a `duration - remaining > actualTime` (44 > 1800) sosem teljesült,
        //    így a játékos az új félidőben nem látszott kiállítottnak (bekerülhetett
        //    a kezdőcsapatba);
        //  - a játékidő-számítás a 44. mp-től a félidő végéig pályán lévőnek vette
        //    (Pődör Blanka: 78:59 egy 60 perces meccsen).
        // Most minden abszolút időben számolódik: a rejtett másolat az EREDETI
        // kezdési idővel kerül át, a vége így a valódi (pl. 30:44), és a
        // hátralévő idő a kiállítás vége és az aktuális idő különbsége.
        let previousPeriodEnd = self.getPeriodStartTime(previousPeriod.value) + parseInt(previousPeriod.duration || 1800);
        self.allItems.forEach(function (item) {
          if (item.period === previousPeriod.value && !item.deleted && (["Hivatalos Kiállítás", "Kiállítás"].includes(item.action))) {
            item.duration = item.duration ?? "02:00";
            let excludeStart = TimeFormatter.stringToInt(item.time);
            let excludeEnd = excludeStart + TimeFormatter.stringToInt(item.duration);

            if (excludeEnd > previousPeriodEnd) {
              let actualTime = TimeFormatter.stringToInt(lastTime);
              tempTable.push({...item, period: self.actualPeriod, hidden: true});
              if (excludeEnd > actualTime) {
                let playerExcludeTime = TimeFormatter.intToString(excludeEnd - actualTime);
                if(item.action === "Kiállítás") {
                  let teamText = self.getTeamKey(item.team);
                  let playerIndex = self.getIndex(gamedata[teamText], item.excluded.id);
                  gamedata[teamText][playerIndex].disabled = true;
                  gamedata[teamText][playerIndex].excluded = true;
                  gamedata[teamText][playerIndex].remainingExclude = playerExcludeTime;
                } else if(item.action === "Hivatalos Kiállítás") {
                  let newOfficialExcludes = {...self.officialExcludes};
                  newOfficialExcludes[item.team].push({UUID: item.UUID, id: item.down.id, remainingExclude: playerExcludeTime});
                  self.officialExcludes = newOfficialExcludes;
                }
              }
            }
          }
        });
      }

      self.timelineData = tempTable;

      if (itemFromPeriod) {
        self.loadInteractions(gamedata, lastTime);
      } else {
        eventBus.$emit(CONSTANTS.EVENTS.SET.GAMEDATA, gamedata);
      }

      self.$nextTick(() => {
        let lastTimeSeconds = TimeFormatter.stringToInt(lastTime);
        let relativeSeconds = Math.max(0, lastTimeSeconds - startSeconds);
        let parts = TimeFormatter.splitTimeString(TimeFormatter.intToString(relativeSeconds));

        if (!preserveClock) {
          // === F5 ÁG: Óra beállítása és STOP ===
          if(itemFromPeriod && window.stopwatch.getTotalTimeAsString() === '00:00' && lastTime !== '00:00') {
            eventBus.$emit(CONSTANTS.EVENTS.CLOCK.SET, Number(parts[0]), Number(parts[1]));
            eventBus.$emit(CONSTANTS.EVENTS.CLOCK.STOP);
          } else {
            eventBus.$emit(CONSTANTS.EVENTS.CLOCK.TICK, window.stopwatch.getTotalTimeAsString());
          }
        }
        else {
          // === RC ÁG: Helyreállítás és START ===
          // Ha van értelmes idő (0-nál több), akkor visszaállítjuk
          if (relativeSeconds > 0) {
            //console.log(`[Substitute] RC Recovery: Stopper beállítása (${relativeSeconds}s).`);
            eventBus.$emit(CONSTANTS.EVENTS.CLOCK.SET, Number(parts[0]), Number(parts[1]));
          }

          // Ha a hiba ELŐTT futott az óra, akkor most ELINDÍTJUK
          if (memoryRunning) {
            // Egy pici késleltetés a biztonság kedvéért, hogy a SET befejeződjön
            setTimeout(() => {
              let isPaused = true;
              if (self.$store.getters['clock/isPaused'] !== undefined) {
                isPaused = self.$store.getters['clock/isPaused'];
              }

              // Csak akkor toggle-öljük, ha tényleg áll (nehogy megállítsuk)
              if (isPaused) {
                //console.log(`[Substitute] RC Auto-Start (Mert futott).`);
                eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.PAUSE);
              }
            }, 100);
          }
        }
      });
    },
  },
  computed: {
    ...mapState('substitute', ['playerPlayTime']),
    ...mapGetters('game', [
      'getPlayerById',
      'isPassivePeriod',
      'getPeriodData',
      'getPeriodStartTime',
      'getTeamKey'
    ]),

    keymap() {
      if (this.hotkeys === false) {
        return {};
      }
      if (typeof this.handleSpace !== 'function') {
        return {};
      }
      return {
        'space': this.handleSpace,
        '32': this.handleSpace
      };
    },

    timelineData: {
      get() {
        const sub = this.$store.state.substitute;
        return (sub && Array.isArray(sub.timelineData)) ? sub.timelineData : [];
      },
      set(value) {
        this.SET_TIMELINE_DATA(value);
      }
    },
    allItems: {
      get() {
        const sub = this.$store.state.substitute;
        return (sub && Array.isArray(sub.allItems)) ? sub.allItems : [];
      },
      set(value) {
        this.SET_ALL_ITEMS(value);
      }
    },
    officialExcludes: {
      get() {
        const sub = this.$store.state.substitute;
        return (sub && sub.officialExcludes) ? sub.officialExcludes : { A: [], B: [] };
      },
      set(value) {
        this.SET_OFFICIAL_EXCLUDES(value);
      }
    },

    timelineItems() {
      let self = this;
      let element = self.$el.querySelector(".midContent");
      let timelineWithoutEdited = self.timelineData.filter(function (item) {
        return !item.editing && item.action !== "Kezdőjátékos";
      });

      if(element && element.scrollTop < 250) {
        self.lazyLoadItems = 20;
      }

      const editing = Array.isArray(self.editingTimeline) ? self.editingTimeline : [];

      let rawList = [...timelineWithoutEdited, ...editing].sort(self.compareDesc);

      let mergedList = [];
      let processedUUIDs = [];

      rawList.forEach(item => {
        if (processedUUIDs.includes(item.UUID)) return;

        if (['Kiállítás', '2perc', '4perc', 'kiallitas'].includes(item.action) && item.down && item.down.id) {

          let pairItem = rawList.find(sub =>
              sub.UUID !== item.UUID &&
              sub.time === item.time &&
              sub.down && sub.down.id === item.down.id &&
              ['Kiállítás', '2perc', '4perc', 'kiallitas'].includes(sub.action) &&
              !processedUUIDs.includes(sub.UUID)
          );

          if (pairItem) {
            let mergedItem = {
              ...item,
              action: '4perc',
              duration: '04:00',
              originalUUIDs: [item.UUID, pairItem.UUID]
            };

            mergedList.push(mergedItem);
            processedUUIDs.push(pairItem.UUID);
          } else {
            mergedList.push(item);
          }
        } else {
          mergedList.push(item);
        }

        processedUUIDs.push(item.UUID);
      });

      return mergedList;
    },
    restoreDialogDisabled() {
      let self = this;
      let rtn = false;

      ['A', 'B'].forEach(function (team) {
        self.restoreDialog.teams[team].forEach(function (item) {
          if(!item.selected) {
            rtn = true;
          }
        });
      });

      return rtn;
    },
    playersStatus() {
      let self = this;
      let rtn = {
        'active': {
          A: [],
          B: [],
        },
        'passive': {
          A: [],
          B: [],
        }
      };

      ['A', 'B'].forEach(function (team) {
        let teamText = self.getTeamKey(team);

        [true, false].forEach(function (playing) {
          if (self.gamedata[teamText]) {
            self.gamedata[teamText].forEach(plr => {
              let statement = playing ? plr.playing : !plr.playing;

              if (statement && !plr.excluded && !plr.disabled) {
                let alreadySelected = false;
                let isSelectedGoalkeeper = false;

                self.restoreDialog.teams[team].forEach(function (item) {
                  let itemId = false;

                  if(item.selected) {
                    if(item.selected.id) {
                      itemId = item.selected.id;
                    } else if(typeof item.selected === 'number') {
                      itemId = item.selected;
                    }
                  }

                  if (itemId) {
                    if(itemId === plr.id) {
                      alreadySelected = true;
                    } else if(!playing && plr.goalkeeper) {
                      let tmpPlayer = self.getPlayer(itemId, teamText);

                      if(tmpPlayer.goalkeeper) {
                        isSelectedGoalkeeper = true;
                      }
                    }
                  }
                });

                if (playing || (!plr.goalkeeper || !self.existGoalkeeper(teamText))) {
                  rtn[playing ? 'active' : 'passive'][team].push({
                    id: plr.id,
                    jersey: plr.jersey,
                    name: plr.name,
                    disabled: alreadySelected || isSelectedGoalkeeper,
                  });
                }
              }
            });
          }
        });
      });

      return rtn;
    },
    restoreList() {
      return {
        A: this.restoreDialog.teams['A'].length,
        B: this.restoreDialog.teams['B'].length
      };
    },
    restoreText() {
      return (this.restoreList.A + this.restoreList.B) > 1 ? 'Válassza ki melyik játékosok menjenek fel a pályára!' : 'Válassza ki melyik játékos menjen fel a pályára!'
    }
  },
}
</script>

<style scoped>
.mainContent {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
}

.midContent {
  height: 100%;
  width: 56%;
  flex-shrink: 1;
  display: flex;
  flex-flow: column;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  position: relative;
}

.sideCard {
  height: 100%;
  width: 22%;
  flex-basis: 22%;
  display: flex;
  flex-flow: column;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: nowrap;
  position: relative;
}

.exclude-team {
  font-size: 18px;
  font-weight: bold;
}

.alertBox {
  position: fixed;
  z-index: 1010;
  bottom: 25px;
  left: calc(50% - 350px);
  width: 700px;
}

.add-official-exclude, .delete-official-exclude {
  min-width: 36px !important;
  padding: 0 !important;
}

.delete-official-exclude {
  color: #F73051;
}

.official-exclude-box {
  display: flex;
  flex-flow: column;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
}

.official-time {
  font-size: 12px;
  line-height: 12px;
  margin-top: 2px;
}

@media (max-width: 1550px) {
  .sideCard {
    height: 100%;
    width: 30%;
    flex-basis: 30%;
  }

  .midContent {
    height: 100%;
    width: 40%;
  }
}
</style>
